import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import HeroSlider from "components/Home/HeroSlider";
import HomeSections from "components/Home/HomeSections";
import BannerInfo from "components/Home/BannerInfo";
import StorageService from 'services/StorageService/';
import WarningInfo from "components/Home/WarningInfo";
import Error500 from "components/Error500";
import Loader from 'components/Loader';
import Day from 'dayjs';
import CMSAction from 'actions/CMS';
import PubSub from 'services/PubSub/';
import CMSFactory from "factories/CMS";
import { addClass, removeClass } from 'utils';
import LazyLoadComponent from 'components/LazyLoadComponent';
import PropTypes from 'prop-types';
import BannerTop from 'components/Home/BannerTop';
import FrequentProducts from 'components/FrequentProducts'
import RenderService from 'services/Render'
import CatalogService from 'services/Catalog';
import { actionsType, sectionsOrder } from 'config/constants';
import LoginService from "services/Login/";
import { primeFlag } from 'config';

let warning = null;
let bannerInfo = null;
let bannerTop = null;
let dataHomeTemp = null;
let actions = [];

const getInitialState = () => {
    const data = RenderService.getRenderData();

    if(!(data && (data.cms || data.landing))){
        return {};
    }

    let realDateServer = data.datetime ? Day(data.datetime).format() : null;
    let content = null;
    let heroSlider = null;

    if(data.landing){
        bannerTop = data.landing.acf['banner'];
        content = data.landing.acf.content;
    } else {
        warning = data.cms.warning;
        bannerInfo = data.cms['banner_info'];
        content = data.cms.content;
        heroSlider = data.cms['home-banner']
    }

    return {
        dateServer: CMSFactory.milliseconds(realDateServer),
        content,
        heroSlider
    };
}

const PageContainer = (props) => {
    const { postType, slug, pageId, history } = props;
    const initialState = getInitialState();

    const [dateServer, setDateServer] = useState(initialState.dateServer || '');
    const [isLoading, setIsLoading] = useState(!initialState.content);
    const [isLoadingIsland, setIsLoadingIsland] = useState(!initialState.content);
    const [content, setContent] = useState(initialState.content || []);
    const [heroSlider, setHeroSlider] = useState(initialState.heroSlider || []);

    useEffect(() => {
        addClass(document.body, 'home-body');

        if(pageId){
            CMSAction.getPage(pageId).then(_getHome);
        } else if (postType && slug) {
            CMSAction.getPostType(postType, slug).then(_getHome);
        }
        actions.push(PubSub.register(actionsType.LOGGED_IN, () => {
            renderDataBanners(dataHomeTemp.acf.banners);
            renderDataIslands(dataHomeTemp)
        } ))


        return function cleanup() {
            actions.map(token => PubSub.unregister(token))
            actions = [];

            PubSub.dispatch('header_menu_fixed', {
                fixed: false
            });

            removeClass(document.body, 'home-body');
        }

    }, [pageId, slug]);

    useEffect(() => {
        const openDrawerPrime = window?.location?.pathname.includes('registrate-prime');
        if(openDrawerPrime && primeFlag){
            setTimeout(() => _openDrawerPrime(), 500);
            history.replace('/');
        }
    }, []);

    const _openDrawerPrime = () => {
        if(LoginService.isLogged()) {
            const _userData = StorageService.getSecureItem('userData');
            const isPrime = _userData.CencoPrime_2020 || _userData.CencoPrime_CAT;
            if(isPrime){
                history.push('/prime');
            }else{
                PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_OPEN);
            }
        } else {
            PubSub.dispatch('login_open', {
                successCallback: () => {
                    setTimeout(() => {
                        PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_CLOSE);
                    }, 1);
                }
            });
        }
    }


    const _getHome = (data) => {
        if (!data) {
            setIsLoading(false);
            setContent([]);
            return false;
        }
        if (!(data.acf)) {
            const search = slug ? `?ft=${slug}` : '';
            history.push(`/Sistema/busquedavacia${search}`);
            return false;
        }
        dataHomeTemp = data;
        let dataBannersHero = data.acf.banners
        let realDateServer = data.datetime ? Day(data.datetime).format() : null;
        setDateServer(CMSFactory.milliseconds(realDateServer));
        warning = data.acf.warning;
        bannerInfo = data.acf['banner_info'];
        bannerTop = data.acf['banner'];
        renderDataBanners(dataBannersHero);
        renderDataIslands(data);
    }

    const renderDataBanners = (dataBanners) =>{
        setIsLoading(true);
        const bannersOrder = _getDataBannerOrder(dataBanners)?.toString();

        const promise = bannersOrder && bannersOrder?.split(',')?.length > 1 ? CatalogService.getOrderRanking(bannersOrder) : Promise.resolve(null);
        promise.then((response) => {
            const skusBannersOrdered = response;

            if(!skusBannersOrdered) {
                setHeroSlider(dataBanners);
                setIsLoading(false);
                return '';
            }
            
            const dataHomeBanners = dataBanners.map((itemBanner) => {
                
                if(!!itemBanner.sku_order && bannersOrder.indexOf(itemBanner.sku_order) !== -1) {
                    const newBanner = dataBanners.filter(_content => _content.sku_order === skusBannersOrdered[0])[0]
                    skusBannersOrdered.shift();
                    return newBanner;
                }
                return itemBanner
            });
            setHeroSlider([...dataHomeBanners]);
            setIsLoading(false);
        }).catch(() => {
            setHeroSlider(dataBanners)
            setIsLoading(false);
        })
    }

    const renderDataIslands = (data) => {
        setIsLoadingIsland(true);
        const skusWithoutOrder = [];
        const dataFilter = [];
        
        data.acf.content.forEach((content) => {
            if(content.sku_order && sectionsOrder.findIndex((shelf) => shelf === content.acf_fc_layout) !== -1 && dataFilter.indexOf(content.acf_fc_layout) == -1){
                dataFilter.push(content.acf_fc_layout);
            }
        })
        dataFilter.forEach(section => {
            skusWithoutOrder.push(_getDataHomeOrder(data.acf.content, section).toString())
        })
        const skusUrl = skusWithoutOrder.join('&skus=');
        
        CatalogService.getOrderRanking(skusUrl).then((response) => {
            if(!(response && response.length)) {
                setContent(data.acf.content);
                setIsLoadingIsland(false);
                return '';
            }
            if(skusWithoutOrder.length === 1){
                response = [response];
            }
            const _response = response.map(item => {
                return item.filter(Boolean);
            })
            let skusWithOrder = _response;
            const dataHome = data.acf.content.map((itemHome) => {
                const indexIslands = dataFilter.indexOf(itemHome.acf_fc_layout);
                if(indexIslands !== -1 && skusWithOrder[indexIslands].length && itemHome.sku_order) {
                    const newIsland = data.acf.content.filter(_content => _content.sku_order === skusWithOrder[indexIslands][0] && dataFilter[indexIslands] === _content.acf_fc_layout)[0];
                    skusWithOrder[indexIslands].shift();
                    return newIsland;
                }

                return itemHome
            });
            setIsLoadingIsland(false);
            setContent(dataHome);
        }).catch(() => {
            setContent(data.acf.content)
            setIsLoadingIsland(false);
        })
    }

    const _getDataBannerOrder = (data) => {
        return data && data.length && data.map((_item)=> {
            if(!_item.sku_order) return null;
            return _item.sku_order;
        }).filter(Boolean)
    }

    const _getDataHomeOrder = (data, type) => {
        return data && data.length && data.map((_item)=> {
            if(!_item.sku_order) return null;
            return type === _item.acf_fc_layout ? _item.sku_order : null;
        }).filter(Boolean)
    }

    let children = [];
    let homeSection = [];

    content.map((element, i) => {
        children.push(<HomeSections element={element} i={i} key={element.acf_fc_layout + i} dateServer={dateServer} />);

        if(pageId && i === 0){
            children.push(<FrequentProducts key={'frequentProducts'}/>);
        }

        if(((i + 1) % 8) === 0 && (i < (content.length - 1))){
            homeSection.push(<LazyLoadComponent key={i+999}> {[...children]} </LazyLoadComponent>);
            children = [];
        }

        if ((i > 0) && (i === (content.length - 1))) {
            homeSection.push(<LazyLoadComponent key={i}> {[...children]} </LazyLoadComponent>);
            children = [];
        }
        return homeSection
    });

    return (
        <div className="home-page-container">
            {isLoading && <div className="home-loader"><Loader /></div>}
            {!isLoading && warning && warning.active && <WarningInfo content={warning} />}
            {!isLoading && bannerInfo && bannerInfo.active && <BannerInfo content={bannerInfo} />}
            {!isLoading && heroSlider?.length && !(bannerInfo && bannerInfo.active) && <HeroSlider heroSlider={heroSlider} dateServer={dateServer}/>}
            {!isLoading && bannerTop && bannerTop.active && <BannerTop banner={bannerTop}  />}

            <div className="container-new-home">
                <main className="home-page-content">
                    {!isLoadingIsland && !(content && content.length > 0) && <Error500 />}
                    {(!isLoadingIsland && content && content.length > 0) ? homeSection : ''}
                </main>
            </div>
        </div>
    )

}

PageContainer.propTypes = {
    postType: PropTypes.string,
    slug: PropTypes.string,
    pageId: PropTypes.number,
    history: PropTypes.object
};

export default withRouter(PageContainer);
